import React from "react";
import { Bar } from "react-chartjs-2";

/**
 * AvgSpendGuestReport
 *
 * Renders a bar chart of average spend vs guest count by month,
 * along with a print-only details table.
 *
 * Props:
 * - chartData: { labels: string[], datasets: Array }
 * - chartOptions: Object
 * - storess: string (store name)
 * - chartRef: React.RefObject
 * - containerId: string
 */
const AvgSpendGuestReport = ({
  chartData,
  chartOptions,
  storess,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <Bar data={chartData} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Month</th>
              <th className="ms-5">Avg Spend</th>
              <th className="ms-5">Guest Count</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td>{label} ------</td>
                <td>{chartData.datasets[0].data[index].toFixed(2)} ------</td>
                <td>{chartData.datasets[1].data[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default AvgSpendGuestReport;
